/**
 * Arena profiles: each battlefield has its own physics (rim size, center-pull,
 * ring-out threshold) and a tint over the shared dish/background art. The
 * "Tech Lab" profile reproduces the baseline tuning exactly (no regression).
 */
import { WORLD, PHYS } from './world.ts';

export interface ArenaProfile {
  id: string;
  name: string;
  blurb: string;
  /** Rim radius (lip of the dish) in world px. */
  rim: number;
  /** Center-pull strength (per-frame accel per unit distance). */
  pull: number;
  /** Outward radial speed above which a knocked bey rings out. */
  ringOutSpeed: number;
  /** Multiply tint for the dish sprite (0xRRGGBB; white = unchanged). */
  dishTint: number;
  /** Multiply tint for the background image. */
  bgTint: number;
}

export const ARENAS: readonly ArenaProfile[] = [
  {
    id: 'lab',
    name: 'Tech Lab',
    blurb: 'A balanced standard dish.',
    rim: WORLD.arena.rim,
    pull: PHYS.pull,
    ringOutSpeed: PHYS.ringOut.speed,
    dishTint: 0xffffff,
    bgTint: 0xffffff,
  },
  {
    id: 'crucible',
    name: 'The Crucible',
    blurb: 'A tight ring — ring-outs come fast. Favors attackers.',
    rim: 250,
    pull: 0.0005,
    ringOutSpeed: 6.6,
    dishTint: 0xff9e7a,
    bgTint: 0xffb38a,
  },
  {
    id: 'expanse',
    name: 'The Expanse',
    blurb: 'A wide arena — hard to knock out. Rewards stamina & control.',
    rim: 345,
    pull: 0.0004,
    ringOutSpeed: 9.5,
    dishTint: 0x8fc2ff,
    bgTint: 0x9fc8ff,
  },
] as const;

export const getArena = (id: string): ArenaProfile =>
  ARENAS.find((a) => a.id === id) ?? ARENAS[0];
